export default "__VITE_ASSET__16918e24__"